var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ReservationBuilder } from '../builders/reservation-builder';
import { ApiService } from './api.service';
import { AuthenticatedApiService } from './authenticated-api.service';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
import * as i2 from "./api.service";
import * as i3 from "../services/authentication.service";
export class ReservationsApiService {
    constructor(api, unauthenticatedApi, auth) {
        this.api = api;
        this.unauthenticatedApi = unauthenticatedApi;
        this.auth = auth;
    }
    listReservations(onlyActive, isAgency, company_id, disableLoader, includeCompanyReservations) {
        let only_active = onlyActive || false;
        let disable_loader = disableLoader || false;
        let include_company_reservations = includeCompanyReservations || false;
        if (isAgency) {
            return this.api.get('/agency/list_reservations?only_active=' + only_active + '&disable_loader=' + disable_loader + '&include_company_reservations=' + include_company_reservations).toPromise().then(response => {
                return response.reservations.map(data => ReservationBuilder.buildReservation(data));
            });
        }
        return this.api.get('/reservation/list?only_active=' + only_active + '&disable_loader=' + disable_loader + '&include_company_reservations=' + include_company_reservations, { company_id }).toPromise().then(response => {
            let reservations = response.reservations.map(data => ReservationBuilder.buildReservation(data));
            return reservations;
        });
    }
    listSporadicReservationsHistory() {
        return this.api.get('/reservation/sporadic_reservations_history', {}).toPromise().then(response => {
            return response.reservations.map(data => ReservationBuilder.buildReservation(data));
        });
    }
    createReservation(reservation, isGuestUser) {
        const payload = ReservationBuilder.buildReservationPayload(reservation);
        return isGuestUser ?
            this.unauthenticatedApi.post('/reservation', JSON.stringify(payload)).toPromise()
                .then(response => ReservationBuilder.buildReservation(response.reservation))
                .catch((error) => this.manageAlternativeOfferError(error)) :
            this.api.post('/reservation', JSON.stringify(payload)).toPromise()
                .then(response => ReservationBuilder.buildReservation(response.reservation))
                .catch((error) => this.manageAlternativeOfferError(error));
    }
    manageAlternativeOfferError(error) {
        var _a, _b;
        if (error.error.error === 'API_ERROR_RESERVATION_OUT_OF_STOCK') {
            if ((_a = error.error.alternative_offer) === null || _a === void 0 ? void 0 : _a.reservation)
                error.error.alternative_offer.reservation = ReservationBuilder.buildReservation(error.error.alternative_offer.reservation);
            if ((_b = error.error.alternative_offer) === null || _b === void 0 ? void 0 : _b.offer)
                error.error.alternative_offer.offer = ReservationBuilder.buildOffer(error.error.alternative_offer.offer);
            throw new HttpErrorResponse(error);
        }
        else {
            throw new HttpErrorResponse(error);
        }
    }
    getReservation(id, user_info = false, format, disableLoader) {
        const queryParams = { format, user_info };
        let disable_loader = disableLoader || false;
        return this.api.get(`/reservation/${id}` + '?disable_loader=' + disable_loader, queryParams).toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation, response.user);
        });
    }
    getReservationWithCarServiceDiscount(id, user_info = false, format) {
        const queryParams = {
            user_info: true,
            calculate_discount_for_carservice: true,
        };
        return this.api.get(`/reservation/${id}`, queryParams).toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation, response.user);
        });
    }
    getReservationByHash(id, hash, isAgency, format) {
        const queryParams = { format };
        return isAgency ?
            this.unauthenticatedApi.get(`/agency/reservation/${id}/${hash}`, queryParams).toPromise()
                .then(response => ReservationBuilder.buildReservation(response.reservation)) :
            this.unauthenticatedApi.get(`/reservation/${id}/${hash}`, queryParams).toPromise()
                .then(response => ReservationBuilder.buildReservation(response.reservation));
    }
    cancelReservation(id) {
        return this.api.delete(`/reservation/${id}`).toPromise().then(response => response);
    }
    update(id, payload) {
        return this.api.put(`/reservation/${id}`, JSON.stringify(payload))
            .toPromise().then(response => ReservationBuilder.buildReservation(response.reservation));
    }
    updateReservation(reservation, isGuestUser) {
        console.log("this method is deprecated. use update method instead.");
        const payload = ReservationBuilder.buildReservationPayload(reservation);
        const reservationToken = 'res_' + reservation.id.toString() + '_' + reservation.hash;
        return isGuestUser ?
            this.unauthenticatedApi.put(`/reservation/${reservation.id}?access_token=${reservationToken}`, JSON.stringify(payload))
                .toPromise().then(response => ReservationBuilder.buildReservation(response.reservation)) :
            this.api.put(`/reservation/${reservation.id}`, JSON.stringify(payload))
                .toPromise().then(response => ReservationBuilder.buildReservation(response.reservation));
    }
    updateReservationPayment(reservationId, paymentId, profileId, usePoints) {
        const payload = ReservationBuilder.buildReservationPaymentUpdatePayload(paymentId, profileId, usePoints);
        return this.api.put(`/reservation/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation);
        });
    }
    updateReservationBillingDetails(reservationId, reservation) {
        const payload = ReservationBuilder.buildReservationBillingDetailsPayload(reservation);
        return this.api.put(`/reservation/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation);
        });
    }
    updateReservationVehicle(reservationId, vehicle) {
        const payload = ReservationBuilder.buildReservationVehicleUpdatePayload(vehicle);
        return this.api.put(`/reservation/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation);
        });
    }
    updateReservationDate(reservationId, startDate, endDate) {
        const payload = ReservationBuilder.buildReservationDateUpdatePayload(startDate, endDate);
        return this.api.put(`/reservation/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation);
        });
    }
    updateReservationTerminalCheckIn(reservationId, checkInTerminalID) {
        const payload = ReservationBuilder.buildReservationTerminalCheckInPayload(checkInTerminalID);
        return this.api.put(`/reservation/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation);
        });
    }
    updateReservationTerminalCheckOut(reservationId, checkOutTerminalID) {
        const payload = ReservationBuilder.buildReservationTerminalCheckOutPayload(checkOutTerminalID);
        return this.api.put(`/reservation/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation);
        });
    }
    updateReservationPassengersCheckIn(reservationId, checkInPassegers) {
        const payload = ReservationBuilder.buildReservationPassengersCheckInPayload(checkInPassegers);
        return this.api.put(`/reservation/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation);
        });
    }
    updateReservationPassengersCheckOut(reservationId, checkOutPassegers) {
        const payload = ReservationBuilder.buildReservationPassengersCheckOutPayload(checkOutPassegers);
        return this.api.put(`/reservation/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation);
        });
    }
    updateReservationFlightNumber(reservationId, flightNumber) {
        const payload = ReservationBuilder.buildReservationFlightNumberPayload(flightNumber);
        return this.api.put(`/reservation/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            return ReservationBuilder.buildReservation(response.reservation);
        });
    }
    pay(reservation) {
        const payload = {
            reservation_id: reservation.id,
            profile_id: reservation.profileId,
            paymethod_id: reservation.paymentMethodId
        };
        return this.api.post('/reservation/pay', JSON.stringify(payload))
            .toPromise().then(response => response);
    }
    requestCheckout(reservation) {
        const payload = {
            reservation_id: reservation.id,
            profile_id: reservation.profileId,
            paymethod_id: reservation.paymentMethodId,
            use_points: reservation.usePoints
        };
        return this.api.post('/reservation/checkout_request', JSON.stringify(payload))
            .toPromise().then(response => ReservationBuilder.buildReservation(response.reservation));
    }
    requestPremiumService(service) {
        let payload;
        if (service.position || service.prediction) {
            payload = ReservationBuilder.buildPremiumServiceRequestPayload(service);
        }
        return this.api.post(`/reservation/premium/${service.reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            return response;
        });
    }
    cancelPremiumService(reservationId) {
        return this.api.delete(`/reservation/premium/${reservationId}`)
            .toPromise()
            .then(response => response);
    }
    updatePremiumServiceLocation(reservationId, lat, lng) {
        const payload = {
            position: { lat, lng }
        };
        return this.api.put(`/reservation/premium/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            if (response.reservation) {
                return ReservationBuilder.buildPremiumStatus(response.reservation.status.premium);
            }
            else {
                return response;
            }
        });
    }
    updatePremiumServiceTracking(reservationId, lat, lng, distance, duration, status) {
        const payload = {
            position: { lat, lng },
            prediction: { distance, duration, status }
        };
        return this.api.put(`/reservation/premium/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            if (response.reservation) {
                return ReservationBuilder.buildPremiumStatus(response.reservation.status.premium);
            }
            else {
                return response;
            }
        });
    }
    updatePremiumServicePickupEta(reservationId, duration, status) {
        const payload = {
            prediction: {
                duration,
                status
            }
        };
        return this.api.put(`/reservation/premium/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            if (response.reservation) {
                return ReservationBuilder.buildPremiumStatus(response.reservation.status.premium);
            }
            else {
                return response;
            }
        });
    }
    getPremiumServiceTracking(reservationId) {
        return this.api.get(`/reservation/premium/${reservationId}`)
            .toPromise().then(response => {
            if (response.reservation) {
                return ReservationBuilder.buildPremiumStatus(response.reservation.status.premium);
            }
            else {
                return response;
            }
        });
    }
    qrScan(reservationId, content) {
        const payload = {
            reservation_id: reservationId,
            qrscan: content
        };
        return this.api.post('/reservation/qrscan', JSON.stringify(payload))
            .toPromise().then(response => {
            if (response.reservation) {
                ReservationBuilder.buildReservation(response.reservation);
            }
            else {
                return response;
            }
        });
    }
    getTicket(reservationId, format) {
        return this.api.get(`/reservation/ticket?reservation_id=${reservationId}`, { format })
            .toPromise().then(response => response);
    }
    calculatePrice(priceRequest, forceGuest) {
        return __awaiter(this, void 0, void 0, function* () {
            let accessToken = this.auth.getAccessToken();
            const payload = {
                product_id: priceRequest.productId,
                start_date: priceRequest.startDate.toISOString(),
                end_date: priceRequest.endDate.toISOString(),
                id_space_extra: priceRequest.id_space_extra || null,
                id_wash_extra: priceRequest.id_wash_extra || null,
                id_mechanical_estimate: priceRequest.id_mechanical_estimate || null,
                add_car_service: priceRequest.add_car_service || null,
                delete_id_car_service: priceRequest.delete_id_car_service || null,
                promocode: priceRequest.promoCode || null,
                use_points: priceRequest.use_points,
                check_availability: priceRequest.check_availability || null,
                check_carservice_availability: priceRequest.check_carservice_availability || null,
                absuid: priceRequest.absuid || null,
                form_version: priceRequest.form_version || null,
                step: priceRequest.step || null,
                experiment: priceRequest.experiment || null,
                screen_resolution: priceRequest.screen_resolution || null,
                in_passengers: priceRequest.in_passengers || null,
                out_passengers: priceRequest.out_passengers || null,
                in_terminal: priceRequest.in_terminal || null,
                out_terminal: priceRequest.out_terminal || null,
                ship: priceRequest.ship || null,
                trip: priceRequest.trip || null
            };
            if (accessToken && !forceGuest) {
                const response = yield this.api.post(`/reservation/calculate/${priceRequest.productId}`, payload).toPromise();
                return ReservationBuilder.buildCalculatedPrice(response);
            }
            else {
                const response = yield this.unauthenticatedApi.post(`/reservation/calculate/${priceRequest.productId}`, payload).toPromise();
                return ReservationBuilder.buildCalculatedPrice(response);
            }
        });
    }
    calculatePriceFromReservation(reservation_id, reservation_hash, priceRequest, disableLoader) {
        return __awaiter(this, void 0, void 0, function* () {
            let accessToken = this.auth.getAccessToken();
            let payload = {};
            if (priceRequest) {
                payload = {
                    product_id: priceRequest.productId || null,
                    start_date: priceRequest.startDate ? priceRequest.startDate.toISOString() : null,
                    end_date: priceRequest.startDate ? priceRequest.endDate.toISOString() : null,
                    id_space_extra: priceRequest.id_space_extra || null,
                    id_wash_extra: priceRequest.id_wash_extra || null,
                    id_mechanical_estimate: priceRequest.id_mechanical_estimate || null,
                    add_car_service: priceRequest.add_car_service || null,
                    delete_id_car_service: priceRequest.delete_id_car_service || null,
                    promocode: priceRequest.promoCode || null,
                    use_points: priceRequest.use_points || null,
                    id_reservation: priceRequest.id_reservation || null,
                    check_availability: priceRequest.check_availability || null,
                    absuid: priceRequest.absuid || null,
                    form_version: priceRequest.form_version || null,
                    step: priceRequest.step || null,
                    experiment: priceRequest.experiment || null,
                    screen_resolution: priceRequest.screen_resolution || null,
                    in_passengers: priceRequest.in_passengers || null,
                    out_passengers: priceRequest.out_passengers || null,
                    in_terminal: priceRequest.in_terminal || null,
                    out_terminal: priceRequest.out_terminal || null,
                    trip: priceRequest.trip || null
                };
            }
            else {
                payload = {
                    id_reservation: Number(reservation_id)
                };
            }
            let disable_loader = disableLoader || false;
            if (accessToken) {
                const response = yield this.api.post(`/reservation/calculate/${reservation_id}/${reservation_hash}` + '?disable_loader=' + disable_loader, payload).toPromise();
                return ReservationBuilder.buildCalculatedPrice(response);
            }
            else {
                const response = yield this.unauthenticatedApi.post(`/reservation/calculate/${reservation_id}/${reservation_hash}` + '?disable_loader=' + disable_loader, payload).toPromise();
                return ReservationBuilder.buildCalculatedPrice(response);
            }
        });
    }
    calculatePriceFromAbsuid(absuid) {
        return __awaiter(this, void 0, void 0, function* () {
            let accessToken = this.auth.getAccessToken();
            let payload = {};
            payload = {
                absuid: absuid || null
            };
            if (accessToken) {
                const response = yield this.api.post(`/reservation/calculate_from_absuid?check_availability=true&show_rsys_status=true`, payload).toPromise();
                return ReservationBuilder.buildCalculatedPrice(response);
            }
            else {
                const response = yield this.unauthenticatedApi.post(`/reservation/calculate_from_absuid?check_availability=true&show_rsys_status=true`, payload).toPromise();
                return ReservationBuilder.buildCalculatedPrice(response);
            }
        });
    }
    calculatePriceforCarService(priceRequest) {
        const query = {
            lang: priceRequest.lang,
            extras: priceRequest.extras,
            start_date: priceRequest.startDate.toISOString(),
            end_date: priceRequest.endDate.toISOString(),
            promocode: priceRequest.promoCode,
            calculate_discount_for_carservice: true,
            trip: priceRequest.trip || null
        };
        return this.unauthenticatedApi.get(`/reservation/calculate/${priceRequest.productId}`, query)
            .toPromise().then(response => ReservationBuilder.buildCalculatedPrice(response));
    }
    premiumUserHasArrived(id) {
        return this.api.post(`/reservation/premium_user_has_arrived/${id}`)
            .toPromise().then(response => {
            if (response.reservation) {
                return ReservationBuilder.buildPremiumStatus(response.reservation.status.premium);
            }
            else {
                return response;
            }
        });
    }
    registerReservation(reservation_id, params) {
        const payload = Object.assign({}, params);
        return this.api.put(`/reservation/register_reservation/${reservation_id}`, JSON.stringify(payload))
            .toPromise().then(response => ReservationBuilder.buildReservation(response.reservation));
    }
    sendRegisterReservationPasswordReminder(reservation_id) {
        return this.unauthenticatedApi.post(`/reservation/send_register_reservation_password_reminder/${reservation_id}`)
            .toPromise().then(response => response);
    }
    importSporadicReservation(reservationId) {
        return this.api.post(`/reservation/import_sporadic_reservation/${reservationId}`, {}).toPromise()
            .then(response => ReservationBuilder.buildReservation(response.reservation));
    }
}
ReservationsApiService.ɵfac = function ReservationsApiService_Factory(t) { return new (t || ReservationsApiService)(i0.ɵɵinject(i1.AuthenticatedApiService), i0.ɵɵinject(i2.ApiService), i0.ɵɵinject(i3.AuthenticationService)); };
ReservationsApiService.ɵprov = i0.ɵɵdefineInjectable({ token: ReservationsApiService, factory: ReservationsApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(ReservationsApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }, { type: i2.ApiService }, { type: i3.AuthenticationService }]; }, null); })();
//# sourceMappingURL=reservations-api.service.js.map